<template>
  <div>
    <vue-seamless-scroll
      :data="listData"
      :class-option="defaultOption2"
      class="seamless-warp"
    >
      <div class="maintenance-type">
        <div>
          <div
            v-for="(item, index) in listData"
            :key="index"
            class="list-class"
          >
            <div class="full-insurance-text text14" @click="getMaintenance(item)">
              <i class="lcon"></i>
              <span class="full-insurance-text-name">{{ item.name }}:</span>
              <span>{{ item.value*9 }}台</span>
            </div>
          </div>
        </div>
      </div>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import vueSeamless2 from "vue-seamless-scroll";
export default {
  name: "seamless",
  components: {
    vueSeamless2,
  },
  props: {
    listData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      
    };
  },
  methods:{
      getMaintenance(item){
          console.log(item)
          this.$emit('getMaintenance',item)
      }
  },
  computed: {
    defaultOption2() {
      return {
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: 4, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
};
</script>
<style scoped>
.seamless-warp {
  width: 162px;
  height: 108px;
  overflow: hidden;
}
.maintenance-type {
    cursor: pointer
  /* width: 162px;
  height: 108px; */
  /* overflow: hidden;
  overflow-y: scroll; */
  /* cursor:pointer;
  overflow: hidden */
}
.full-insurance-text {
  margin-left: 18px;
  margin-bottom: 8px;
  color: #ffffff;
}
.full-insurance-text-name {
  width: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/maintenance-type.vue